interface state extends types.redux.rootReducer { }

export const fbbPlanSelector = ({ fbbPlans }: any) => fbbPlans;
